import "./instrument";
import React from "react";
import { createRoot } from "react-dom/client";
import posthog from "posthog-js";
import App from "./App.tsx";
import "./index.css";

const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: "https://e.promptwizer.com",
    ui_host: "https://us.posthog.com",
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: false,
    persistence: "localStorage+cookie",
    capture_heatmaps: true,
    enable_recording_console_log: true,
    __add_tracing_headers: false,
    web_vitals_allowed_metrics: ["LCP", "INP", "CLS", "FCP"],
    person_profiles: "identified_only",
    defaults: "2026-05-30",
  });
}

createRoot(document.getElementById("root")!).render(<App />);
